"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var CardRowSelectEditor_1 = require("../../../../shared/components/editors/CardRowSelectEditor");
var CardRowNumericEditor_1 = require("../../../../shared/components/editors/CardRowNumericEditor");
var CardRowCheckBoxEditor_1 = require("../../../../shared/components/editors/CardRowCheckBoxEditor");
var DlgAddGameToAllCmsGameSetLists = /** @class */ (function (_super) {
    __extends(DlgAddGameToAllCmsGameSetLists, _super);
    function DlgAddGameToAllCmsGameSetLists(props) {
        var _this = _super.call(this, props) || this;
        _this.SID_GP = 0;
        _this.SID_GP_G = 0;
        _this.SID_GP_C = 0;
        return _this;
    }
    DlgAddGameToAllCmsGameSetLists.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_APP_C = this.props.listAppCurrencyAvail.Subscribe("*", function (id, data) {
            _this.setState({
                currency_id: 0,
                currency_title: "",
                currencies_avail: data.data
            });
        });
        this.SID_GP = this.props.listGameProvidersAvail.Subscribe("*", function (id, data) {
            _this.setState({
                gameproviders_avail: data.data,
                gameprovider_id: 0,
                gameprovider_title: "",
                gameprovider_game_id: 0,
                gameprovider_game_title: "",
                gameprovider_games_avail: [],
            });
        });
        this.SID_GP_G = this.props.listGwsGameProviderGamesAvail.Subscribe("*", function (id, data) {
            _this.setState({
                gameprovider_game_id: 0,
                gameprovider_game_title: "",
                gameprovider_games_avail: data.data
            });
        });
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                dialogTitle: data.dialogTitle,
                gameprovider_id: 0,
                gameprovider_title: "",
                gameproviders_avail: [],
                gameprovider_game_id: 0,
                gameprovider_game_title: "",
                gameprovider_games_avail: [],
                currency_id: 0,
                currency_title: "",
                currencies_avail: [],
                is_table_game: false,
                is_add_to_top: false,
                top_game_offset: 5,
            }, function () {
                if (_this.state.visible) {
                    _this.props.listGameProvidersAvail.LoadData();
                    _this.props.listAppCurrencyAvail.LoadData();
                }
            });
        });
        this.setState({
            visible: false,
            dialogTitle: "",
            gameprovider_id: 0,
            gameprovider_title: "",
            gameproviders_avail: [],
            gameprovider_game_id: 0,
            gameprovider_game_title: "",
            gameprovider_games_avail: [],
            currency_id: 0,
            currency_title: "",
            currencies_avail: [],
            is_table_game: false,
            is_add_to_top: false,
            top_game_offset: 5,
        });
        this.doReSetRules();
    };
    DlgAddGameToAllCmsGameSetLists.prototype.doReSetRules = function () {
        this.setState({
            gameprovider_rules: { isError: false },
            gameprovider_game_rules: { isError: false },
            currency_rules: { isError: false }
        });
    };
    DlgAddGameToAllCmsGameSetLists.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
        this.props.listGameProvidersAvail.UnSubscribe(this.SID_GP);
        this.props.listGwsGameProviderGamesAvail.UnSubscribe(this.SID_GP_G);
        this.props.listAppCurrencyAvail.UnSubscribe(this.SID_APP_C);
        //this.props.listGwsCategoryAvail.UnSubscribe(this.SID_GP_C);
    };
    DlgAddGameToAllCmsGameSetLists.prototype.isDataValid = function () {
        this.doReSetRules();
        var is_data_valid = true;
        if (this.state.gameprovider_id <= 0) {
            this.setState({
                gameprovider_rules: {
                    isError: true,
                    errorMessage: "Поле [геймпровайдер] не заполнено!"
                },
            });
            is_data_valid = false;
        }
        if (this.state.gameprovider_game_id <= 0) {
            this.setState({
                gameprovider_game_rules: {
                    isError: true,
                    errorMessage: "Поле [игра] не заполнено!"
                },
            });
            is_data_valid = false;
        }
        if (this.state.currency_id <= 0) {
            this.setState({
                currency_rules: {
                    isError: true,
                    errorMessage: "Поле [валюта] не заполнено!"
                },
            });
            is_data_valid = false;
        }
        return is_data_valid;
    };
    DlgAddGameToAllCmsGameSetLists.prototype.handleYes = function () {
        if (this.isDataValid()) {
            this.props.controller.Close();
            if (this.props.controller.DATA.onYes) {
                this.props.controller.DATA.onYes(this.state.gameprovider_id, this.state.gameprovider_game_id, this.state.currency_id, this.state.is_table_game, this.state.is_add_to_top, this.state.top_game_offset);
            }
        }
    };
    DlgAddGameToAllCmsGameSetLists.prototype.handleClose = function () {
        this.props.controller.Close();
    };
    /*private doSelectInactiveCss() {
        this.props.dlgSelectKeyVal.SetTitle("Выбрать CSS класс")
            .SetHideNotAutoCloseDialog(true)
            .SetOnCloseClick(() => { this.props.dlgSelectKeyVal.Close() })
            .SetViewData(this.state.gameprovider_categories_avail)
            .SetOnSelectClick((key, value) => {
                this.setState({
                    gameprovider_category_title: value,
                    //css_inactive_classname_rules: { isError: false }
                }, () => {
                    this.props.dlgSelectKeyVal.Close();
                })
            }).Show();
    }*/
    DlgAddGameToAllCmsGameSetLists.prototype.render = function () {
        var _this = this;
        return React.createElement(antd_1.Modal, { title: this.state.dialogTitle, visible: this.state.visible, onOk: this.handleYes.bind(this), wrapClassName: "vertical-center-modal", onCancel: this.handleClose.bind(this), okText: "\u0414\u0410", cancelText: "\u041D\u0415\u0422", closable: true, maskClosable: false, okType: "primary", style: { minWidth: 550 } },
            React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", } },
                React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Геймпровайдер:", placeholder: "Выберите геймпровайдер" }, value: { key: this.state.gameprovider_id, value: this.state.gameprovider_title }, onValueChanged: function (newVal) {
                        _this.setState({
                            gameprovider_id: newVal.key,
                            gameprovider_title: newVal.value,
                            gameprovider_rules: { isError: false }
                        }, function () {
                            _this.props.listGwsGameProviderGamesAvail.LoadData(_this.state.gameprovider_id);
                        });
                    }, items: this.state.gameproviders_avail, required: true, rules: this.state.gameprovider_rules }),
                React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Игра:", placeholder: "Выберите игру" }, value: { key: this.state.gameprovider_game_id, value: this.state.gameprovider_game_title }, onValueChanged: function (newVal) {
                        _this.setState({
                            gameprovider_game_id: newVal.key,
                            gameprovider_game_title: newVal.value,
                            gameprovider_game_rules: { isError: false }
                        });
                    }, items: this.state.gameprovider_games_avail, required: true, rules: this.state.gameprovider_game_rules }),
                React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Валюта:", placeholder: "Выберите валюту" }, value: { key: this.state.currency_id, value: this.state.currency_title }, onValueChanged: function (newVal) {
                        _this.setState({
                            currency_id: newVal.key,
                            currency_title: newVal.value,
                            currency_rules: { isError: false }
                        });
                    }, items: this.state.currencies_avail, required: true, rules: this.state.currency_rules }),
                React.createElement(CardRowCheckBoxEditor_1.default, { title: "Настольная игра", value: this.state.is_table_game, onChecked: function (checked) { _this.setState({ is_table_game: checked }); } }),
                React.createElement(CardRowCheckBoxEditor_1.default, { title: "Топ игра", value: this.state.is_add_to_top, onChecked: function (checked) { _this.setState({ is_add_to_top: checked }); } }),
                React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Приоритет игры:", placeholder: "Введите приоритет игры" }, values: { min: 0, max: 100, value: this.state.top_game_offset }, onValueChanged: function (newValue) {
                        _this.setState({ top_game_offset: newValue });
                    }, disabled: !this.state.is_add_to_top })));
    };
    return DlgAddGameToAllCmsGameSetLists;
}(React.Component));
exports.default = DlgAddGameToAllCmsGameSetLists;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ui/DlgAddGameToAllCmsGameSetLists.tsx
// module id = 2538
// module chunks = 0